/**
 * Checks if the current page is loaded within an iframe.
 * 
 * @returns {boolean} true if the page is in an iframe, false otherwise
 */
export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Most likely error due to Cross-Origin restrictions, so default to true
    return true;
  }
}
